import React from "react";

function SectionCount(){
     return(
          <div className="head__count">
                <div className="count">
                        <h3>25K+</h3>
                       <small>Client</small>
                
                </div>
                 <div className="count">
                        <h3>75+</h3>
                       <small>Consultants</small>
                
                </div>
                 <div className="count">
                        <h3>100K+</h3>
                       <small id="labels">Registered pet</small>
                       <small>Registered pet</small>
                
                </div>
                 <div className="count">
                        <h3>95%+</h3>
                       <small  id="labels">Customer satisfaction</small>
                       <small>Customer sa</small>
                
                </div>
          
          
          </div>


     )
}
export default SectionCount;